export default __webpack_public_path__ + "static/media/google-en.a71fb026.svg";